/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Contact_Can_Extend_Wrapup_TimeInputs */

const en_forms_teams_settings_contact_can_extend_wrapup_time = /** @type {(inputs: Forms_Teams_Settings_Contact_Can_Extend_Wrapup_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrapup Time`)
};

const de_forms_teams_settings_contact_can_extend_wrapup_time = /** @type {(inputs: Forms_Teams_Settings_Contact_Can_Extend_Wrapup_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann Nachbearbeitungszeit verlängern`)
};

/**
* | output |
* | --- |
* | "Wrapup Time" |
*
* @param {Forms_Teams_Settings_Contact_Can_Extend_Wrapup_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_contact_can_extend_wrapup_time = /** @type {((inputs?: Forms_Teams_Settings_Contact_Can_Extend_Wrapup_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Contact_Can_Extend_Wrapup_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_contact_can_extend_wrapup_time(inputs)
	return de_forms_teams_settings_contact_can_extend_wrapup_time(inputs)
});